// TODO нельзя импортировать @portals/help-center-core https://youtrack.wildberries.ru/issue/INS-862
// https://nextjs.org/docs/messages/edge-dynamic-code-evaluation
// import { ECountry, ELanguage } from '@portals/help-center-core';
import { CATEGORIES_PATH } from '@/_constants/routes';
// NOTE: Нельзя импортировать из @portals/help-center-core/lib/_internal в этом файле,
// так как он используется в middleware.ts (Edge Runtime), который не поддерживает
// динамическую оценку кода. Определяем LANGUAGES_MAP локально.
// import { LANGUAGES_MAP } from '@portals/help-center-core/lib/_internal';

export const COUNTRY_COOKIE = 'x-nextjs-country';

export const ENGLISH_LANGUAGE_CODE = 'en';
export const UNITED_NATIONS_CODE = 'un';

export const LANGUAGES = new Set([
  'ru',
  'am',
  'by',
  'kg',
  'kz',
  'uz',
  'ch',
  'un',
  'tr',
  'ka',
  'tj',
]);
export const COUNTRIES = new Set(['ru', 'en', 'ch', 'tr', 'ge', 'tj']);

export const AVAILABLE_COUNTRIES = [
  'ru',
  'ch',
  'am',
  'by',
  'kz',
  'kg',
  'uz',
  'tj',
  'ge',
];
export const DEFAULT_LANGUAGE = 'ru';
export const DEFAULT_COUNTRY = 'ru';
// process.env.BASE_PATH - undefined для клиенских компонентов
// на клиенте использовать basePath из useClientEnvContext
export const BASE_PATH = `${process.env.BASE_PATH || ''}`;
export const DEFAULT_ROOT_PATH = `/${DEFAULT_LANGUAGE}/${DEFAULT_COUNTRY}${CATEGORIES_PATH}`;

export const UUID_REGEX =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;
export const ARTICLE_REGEX = /^A-\d+$/;
// eslint-disable-next-line security/detect-unsafe-regex
export const SLUG_REGEX = /^(?=.{2,150}$)[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const ISO_2_CODE_REGEXP = /^[a-z]{2}$/;

export const SIDE_MODE_LANGUAGES_MAP: Record<string, Array<string>> = {
  ru: ['ru', 'en'],
  ch: ['ch', 'en', 'ru'],
  am: ['hy', 'en', 'ru'],
  by: ['en', 'ru'],
  kz: ['kk', 'en', 'ru'],
  kg: ['en', 'ru'],
  uz: ['uz', 'en', 'ru'],
  tr: ['tr', 'en', 'ru'],
  tj: ['en', 'ru'],
  ge: ['ka', 'ru'],
  un: ['en'],
};

export const SIDE_MODE_AVAILABLE_LANGUAGES = Object.keys(
  SIDE_MODE_LANGUAGES_MAP,
);

export const COUNTRIES_LANGUAGES_MAP: Record<string, Array<string>> = {
  ru: ['ru'],
  ch: ['ch'],
  am: ['ru'],
  by: ['ru'],
  kz: ['ru'],
  kg: ['ru'],
  uz: ['ru'],
  tj: ['ru'],
  ge: ['ka', 'ru'],
};

export const ML_SEARCH_AVAILABLE: Record<string, Array<string>> = {
  [DEFAULT_COUNTRY]: [DEFAULT_LANGUAGE],
};
